import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Box,
    Button,
    FormControl,
    FormLabel,
    Input,
    VStack,
    Container,
    Heading,
    useToast,
    useBreakpointValue,
} from '@chakra-ui/react';
import { useAuth } from '../contexts/AuthContext';

const ENCRYPTED_PASSWORD = 'RXYzbnRzX0BjYzNzcyEyMDI2';

const decryptPassword = (encrypted: string): string => {
    try {
        return atob(encrypted);
    } catch {
        return '';
    }
};

export const LoginPage: React.FC = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const { login } = useAuth();
    const navigate = useNavigate();
    const toast = useToast();
    
    // Responsive values
    const buttonSize = useBreakpointValue({ base: 'md', md: 'md' });
    const inputSize = useBreakpointValue({ base: 'md', md: 'md' });
    const boxWidth = useBreakpointValue({ base: '90%', sm: '400px' });
    const marginTop = useBreakpointValue({ base: 10, md: 20 });

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        
        const correctPassword = decryptPassword(ENCRYPTED_PASSWORD);
        
        if (username === 'admin' && password === correctPassword) {
            const token = btoa(`${username}:${Date.now()}`);
            login(token);
            navigate('/events');
        } else {
            toast({
                title: 'Login Failed',
                description: 'Invalid credentials',
                status: 'error',
                duration: 3000,
                isClosable: true,
            });
        }
    };

    return (
        <Container centerContent>
            <Box p={{ base: 5, md: 8 }} width="100%" maxWidth={boxWidth} borderWidth={1} borderRadius={8} boxShadow="lg" mt={marginTop}>
                <VStack spacing={4} as="form" onSubmit={handleSubmit}>
                    <Heading>Login</Heading>
                    <FormControl isRequired>
                        <FormLabel>Username</FormLabel>
                        <Input
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            size={inputSize}
                        />
                    </FormControl>
                    <FormControl isRequired>
                        <FormLabel>Password</FormLabel>
                        <Input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            size={inputSize}
                        />
                    </FormControl>
                    <Button 
                        type="submit" 
                        colorScheme="blue" 
                        width="full"
                        size={buttonSize}
                        mt={{ base: 2, md: 4 }}
                    >
                        Login
                    </Button>
                </VStack>
            </Box>
        </Container>
    );
};
